module.exports = __webpack_public_path__ + "static/symbol-background-1d434c4b2ddd2d606feef596c9aecf3c.png";